export default {
    searchByVisitorName: 'Search by Visitor name',
    search: 'Search',
    createNewVisitor: 'Create New Visitor',
    visitorName: 'Visitor Name',
    contact: 'Contact',
    contactNo: 'Contact No.',
    dateCreate: 'Date Create',
    upcomingAccess: 'Upcoming Access',
    status: 'Status',
    action: 'Action',
    delete: 'Delete Visitor',
    deleted: 'Are you sure you want to delete',
    deleteSuccess: 'Delete Visitor'
}
